import { createSlice } from '@reduxjs/toolkit';

import { clearCoachState } from './coachSlice';
import { clearAthleteState } from './athleteSlice';
import { clearAdminState } from './adminSlice';
import AuthService from '../../auth/storage';

const initialState = {
  isAuthenticated: false,
  userId: null,
  role: null,
  email: null,
  loading: false,
  error: null,
  isLoggingOut: false,
  bootstrapped: false,
};

// clear all slices and token
export const logoutUser = () => (dispatch) => {
  dispatch(setLoggingOut(true));
  AuthService.removeToken();
  dispatch(clearAuthState());
  dispatch(clearCoachState());
  dispatch(clearAthleteState());
  dispatch(clearAdminState());
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState(state, action) {
      const { _id, role, email } = action.payload;
      state.isAuthenticated = true;
      state.userId = _id;
      state.role = role;
      state.email = email;
      state.error = null;
      state.isLoggingOut = false;
      state.bootstrapped = true;
    },
    clearAuthState() {
      return { ...initialState, bootstrapped: true };
    },
    setAuthError(state, action) {
      state.error = action.payload;
    },
    setLoggingOut(state, action) {
      state.isLoggingOut = action.payload;
    },
    setBootstrapped(state) {
      state.bootstrapped = true;
    },
  },
});

export const {
  setAuthState,
  clearAuthState,
  setAuthError,
  setLoggingOut,
  setBootstrapped,
} = authSlice.actions;
export default authSlice.reducer;
